import { setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { SiteData } from "../Data/SiteData";
import SiteStyleCollectionMenu from "./SiteStyleCollectionMenu";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultCookieBannerText } from "vagaro-website-rendering/src/components/ComponentRenders/RenderCookieBanner";


export default function CookieBannerMenu({saveFunc,siteData}:{saveFunc:Function,siteData:SiteData}){

    siteData.siteStyling.announcementBar.typename = wBComponentTypeNames.announcementBar;
 

    const linkStyle = {color:"#2479c7",textDecoration:"underline"}
    const header = <div style={{fontSize:"12px",fontWeight:"400",color:"#777"}}>
        {"Display a banner to inform visitors of your site’s cookies consent for handling customer data. For more information review "}
    
    <a target="_blank" rel="noreferrer" href="https://gdpr.eu/" style={linkStyle}>GDPR</a> and 
    <a target="_blank" rel="noreferrer" href="https://oag.ca.gov/privacy/ccpa" style={linkStyle}> CCPA</a>
    {" guidelines."} </div>

    const footer =<> 
    <div  className="relative" style={{background:"#f8f8f8",marginTop:"-42px"}}>
      <button className="invisible-button" style={{fontSize:"16px",fontWeight:"400",color:"#2479c7"}}
      onClick={(e)=>{
        
        setNodeComponentAttributeValue(siteData.siteStyling.cookieBanner,"cookieBannerText",defaultCookieBannerText); 
      
     
        let dom = e.target as HTMLElement;

        let parent = dom.parentElement?.parentElement?.parentElement;
        if(parent){
          let txtArea = parent.querySelector("textarea");
          if(txtArea){
            txtArea.value = defaultCookieBannerText;
            
          }
        }
        siteData.designer?.forceUpdate();
      
      }
      }      
      >Reset to Default</button>
      <hr style={{opacity:".1"}}/>
    <div style={{fontSize:"12px",fontWeight:"400",color:"#777"}}>
        {"Note: Cookie requirements vary. Our default text is a sample for illustration; you shouldn't assume it satisfies your particular legal requirements. Vagaro can't provide you legal advice, including on the content of your confirmation text or your privacy or cookie policy."} </div>
        </div>
        
        </>

  siteData.siteStyling.cookieBanner.typename = wBComponentTypeNames.cookieBanner;

      return <SiteStyleCollectionMenu 
        title="Cookie Banner"
        header={header}
        saveFunc={saveFunc}
        siteData={siteData}
        collectionList={[siteData.siteStyling.cookieBanner]}
        labelList={["Cookie Banner"]}
        componentType={wBComponentTypeNames.cookieBanner}
        includeAll={true}
        saveOnUpdate={true}
        footer={footer}
        hideResetButton={true}
  
      />
  
  }